export function validateBrandLogo(file: Pick<File,'type'|'size'>): string | null {
 if(!['image/png','image/jpeg','image/webp'].includes(file.type))return 'Choose a PNG, JPEG or WebP image.';
 if(file.size<=0||file.size>5*1024*1024)return 'Choose a nonempty image no larger than 5 MB.';
 return null;
}
export async function saveBrandLogo(brandId:number,file:File|null):Promise<Record<string,any>>{
 if(file){const error=validateBrandLogo(file);if(error)throw new Error(error);}
 const body=file?new FormData():undefined;if(file)body!.append('file',file);
 const response=await fetch(`/api/brands/${brandId}/logo`,{method:file?'POST':'DELETE',credentials:'include',...(body?{body}:{})});
 if(!response.ok){let message='Unable to update logo. Please try again.';try{const error=await response.json();message=error.message||error.error||message;}catch{}throw new Error(message);}
 return response.json();
}
